export default __webpack_public_path__ + "static/media/FD1.6c94558f.png";